import { useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { useStore } from "../../GlobalProvider/GlobalProvider";
import { baseUrl } from "../../utils/helper";
import { LiaUserEditSolid } from "react-icons/lia";
import { MdAddToHomeScreen, MdCalendarToday, MdDelete } from "react-icons/md";
import { IoAccessibility } from "react-icons/io5";
import { Dialog } from "primereact/dialog";
import AppointmentUpdateModal from "../Modals/AppointmentUpdateModal/AppointmentUpdateModal";
import PatientUpdateModal from "../Modals/PatientUpdateModal/PatientUpdateModal";
import VisitModal from "../Modals/VisitModal/VisitModal";
import VitalSigns from "../vital-signs/vital-signs";
import moment from "moment";

const statusBorder: Record<string, string> = {
    present: 'border-l-blue-500',
    pending: 'border-l-amber-400',
    completed: 'border-l-[#12AB81]',
    canceled: 'border-l-red-400',
};
const statusBadge: Record<string, string> = {
    present: 'bg-blue-50 text-blue-600',
    pending: 'bg-amber-50 text-amber-700',
    completed: 'bg-green-50 text-green-700',
    canceled: 'bg-red-50 text-red-500',
};
const typeBadge: Record<string, string> = {
    new: 'bg-blue-50 text-blue-600',
    old: 'bg-amber-50 text-amber-600',
    followup: 'bg-purple-50 text-purple-600',
};

const Card = ({ data, update, setUpdate }: any) => {
    const {
        officeLocation, doctorName, patientId, patientName,
        patientPhone, patientBloodGroup, patientGender,
        patientDob, nextVisitInstruction, date, patientAddress, type, status, _id,
    } = data;

    const { token } = useStore();
    const [showAppointmentModal, setShowAppointmentModal] = useState(false);
    const [showVisit, setShowVisit] = useState(false);
    const [showPatientModal, setShowPatientModal] = useState(false);
    const [appointmentData, setAppointmentData] = useState<any>();
    const [patientData, setPatientData] = useState<any>();
    const [show, setShow] = useState(false);
    const [vitals, setVitals] = useState<any>([]);
    const [visitData, setVisitData] = useState({ id: '', reasonForVisit: '', historyOfPresetIllness: '' });
    const [loading, setLoading] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const appointmentUpdateMethod = async (payload: any) =>
        fetch(`${baseUrl}/appointment/update/${_id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify(payload),
        });

    const handleAppointmentSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res: any = await appointmentUpdateMethod({ type: appointmentData?.type, status: appointmentData?.status, date: appointmentData?.date });
            if (res?.ok) { setUpdate(!update); setShowAppointmentModal(false); }
        } catch (err) { console.error(err); } finally { setLoading(false); }
    };

    const handlePatientSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await fetch(`${baseUrl}/patient/update/${patientId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ name: patientData?.name, phone: patientData?.phone, dob: patientData?.dob, gender: patientData?.gender }),
            });
            if (res.ok) {
                const res2 = await appointmentUpdateMethod({ patientName: patientData?.name, patientPhone: patientData?.phone, patientDob: patientData?.dob, patientGender: patientData?.gender, patientAddress: patientData?.address });
                if (res2.ok) { setUpdate(!update); setShowPatientModal(false); }
            }
        } catch (err) { console.error(err); } finally { setLoading(false); }
    };

    const handleVisit = async (id: any) => {
        try {
            const res = await fetch(`${baseUrl}/appointment/create-visit/${id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            });
            const d = await res.json();
            if (res.ok) {
                setVisitData({ id: d?._id, reasonForVisit: d?.reasonForVisit || '', historyOfPresetIllness: d?.historyOfPresetIllness || '' });
                setVitals(d?.vitals);
            }
        } catch (err) { console.error(err); }
    };

    const handlevisitSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await fetch(`${baseUrl}/visit/${visitData?.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ reasonForVisit: visitData?.reasonForVisit, historyOfPresetIllness: visitData?.historyOfPresetIllness }),
            });
            if (res.ok) { setUpdate(!update); setShowVisit(false); }
        } catch (err) { console.error(err); } finally { setLoading(false); }
    };

    const handleVitalsSubmit = async (payload: any, e: any) => {
        try {
            const res = await fetch(`${baseUrl}/visit/${visitData?.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify(payload),
            });
            if (res.ok) { setUpdate(!update); setShow(false); }
        } catch (err) { console.error(err); }
    };

    const handleDelete = async (id: any) => {
        try {
            const res = await fetch(`${baseUrl}/appointment/remove/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            });
            if (res.ok) setUpdate(!update);
        } catch (err) { console.error(err); }
    };

    const initials = patientName ? patientName.charAt(0).toUpperCase() : '?';
    const fullDate = date ? moment(date).format('ddd, D MMM YYYY') : '—';

    const actions = [
        {
            icon: <FaRegEdit size={14} />, label: 'Edit', color: 'text-[#12AB81]',
            onClick: () => { setShowAppointmentModal(true); setAppointmentData({ id: _id, status, type, date }); }
        },
        {
            icon: <MdDelete size={15} />, label: 'Delete', color: 'text-red-400',
            onClick: () => setShowDeleteConfirm(true)
        },
        {
            icon: <MdAddToHomeScreen size={14} />, label: 'Visit', color: 'text-[#12AB81]',
            onClick: () => { setShowVisit(true); handleVisit(_id); }
        },
        {
            icon: <IoAccessibility size={14} />, label: 'Vitals', color: 'text-[#12AB81]',
            onClick: () => { setShow(true); handleVisit(_id); }
        },
        {
            icon: <LiaUserEditSolid size={15} />, label: 'Patient', color: 'text-gray-400',
            onClick: () => {
                if (patientId) {
                    setShowPatientModal(true);
                    setPatientData({ name: patientName, phone: patientPhone, dob: patientDob, gender: patientGender, address: patientAddress });
                }
            }
        },
    ];

    return (
        <div>
            <div className={`bg-white rounded-xl shadow-sm border-l-4 ${statusBorder[status] || 'border-l-gray-300'} overflow-hidden`}>
                {/* Header row */}
                <div className="flex items-start gap-2.5 px-3 pt-3 pb-2">
                    <div className="w-9 h-9 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0">
                        <span className="text-[#12AB81] font-bold text-sm">{initials}</span>
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-1.5">
                            <p className="font-semibold text-gray-800 text-sm truncate flex-1">{patientName}</p>
                            <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-md flex-shrink-0 capitalize ${statusBadge[status] || 'bg-gray-50 text-gray-500'}`}>
                                {status}
                            </span>
                        </div>
                        <div className="flex items-center gap-1 mt-0.5 flex-wrap">
                            {patientId && (
                                <>
                                    <span className="text-xs text-gray-400 font-medium">{patientId}</span>
                                    <span className="text-gray-300 text-xs">·</span>
                                </>
                            )}
                            <span className={`text-[10px] font-medium px-1 py-0.5 rounded capitalize ${typeBadge[type] || 'bg-gray-50 text-gray-500'}`}>{type}</span>
                        </div>
                        <p className="text-[11px] text-gray-400 mt-0.5 truncate">
                            Dr. {doctorName}{officeLocation?.name ? ` · ${officeLocation.name}` : ''}
                        </p>
                        <div className="flex items-center gap-1 mt-1">
                            <MdCalendarToday size={11} className="text-[#12AB81] flex-shrink-0" />
                            <span className="text-[11px] font-medium text-[#12AB81]">{fullDate}</span>
                        </div>
                    </div>
                </div>

                {/* Info pills */}
                {(patientPhone || patientGender || patientBloodGroup) && (
                    <div className="flex items-center gap-1.5 px-3 pb-2.5 flex-wrap">
                        {patientPhone && <span className="text-[11px] text-gray-500 bg-gray-50 px-1.5 py-0.5 rounded-md">{patientPhone}</span>}
                        {patientGender && <span className="text-[11px] text-gray-500 bg-gray-50 px-1.5 py-0.5 rounded-md capitalize">{patientGender}</span>}
                        {patientBloodGroup && <span className="text-[11px] font-semibold text-red-500 bg-red-50 px-1.5 py-0.5 rounded-md">{patientBloodGroup}</span>}
                    </div>
                )}

                {/* Action row */}
                <div className="border-t border-gray-100 grid grid-cols-5">
                    {actions.map((action, i) => (
                        <button
                            key={i}
                            aria-label={action.label}
                            className={`flex flex-col items-center justify-center py-2.5 gap-0.5 active:bg-gray-50 ${i > 0 ? 'border-l border-gray-100' : ''}`}
                            onClick={action.onClick}
                        >
                            <span className={action.color}>{action.icon}</span>
                            <span className={`text-[9px] leading-tight ${action.color}`}>{action.label}</span>
                        </button>
                    ))}
                </div>
            </div>

            <AppointmentUpdateModal
                showAppointmentModal={showAppointmentModal}
                setShowAppointmentModal={setShowAppointmentModal}
                handleAppointmentSubmit={handleAppointmentSubmit}
                appointmentData={appointmentData}
                setAppointmentData={setAppointmentData}
                loading={loading}
            />
            <PatientUpdateModal
                showPatientModal={showPatientModal}
                setShowPatientModal={setShowPatientModal}
                handlePatientSubmit={handlePatientSubmit}
                setPatientData={setPatientData}
                patientData={patientData}
                loading={loading}
            />
            <VisitModal
                showVisit={showVisit}
                setShowVisit={setShowVisit}
                handlevisitSubmit={handlevisitSubmit}
                visitData={visitData}
                setVisitData={setVisitData}
                loading={loading}
            />
            <VitalSigns patient={data?.patient} handleVitalsSubmit={handleVitalsSubmit} vitals={vitals} show={show} setShow={setShow} />

            <Dialog
                visible={showDeleteConfirm}
                style={{ width: "85vw", maxWidth: "360px" }}
                header={null}
                footer={null}
                closable={false}
                onHide={() => setShowDeleteConfirm(false)}
            >
                <div className="pt-2 pb-1">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-50 mx-auto mb-3">
                        <MdDelete className="text-red-500" size={24} />
                    </div>
                    <p className="text-center font-semibold text-gray-800 text-sm mb-1">Delete Appointment?</p>
                    <p className="text-center text-gray-500 text-xs mb-5">
                        This will permanently remove <span className="font-medium text-gray-700">{patientName}</span>'s appointment. This cannot be undone.
                    </p>
                    <div className="flex gap-3">
                        <button
                            className="flex-1 py-2.5 rounded-xl border border-gray-200 text-gray-600 text-sm font-medium active:bg-gray-50"
                            onClick={() => setShowDeleteConfirm(false)}
                        >
                            Cancel
                        </button>
                        <button
                            className="flex-1 py-2.5 rounded-xl bg-red-500 text-white text-sm font-semibold active:bg-red-600"
                            onClick={() => { handleDelete(_id); setShowDeleteConfirm(false); }}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default Card;
